/* eslint-disable no-var */
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetGlChartOfAccountsDetailsList } from '@store/Finance/ChartAccounts/ChartAccountsDetailsSlice';
import { useTranslation } from 'react-i18next';

const useGetChartAccountsDetailsList = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { ChartAccountsDetails, ChartDetiles, loading, error } = useAppSelector(state => state.ChartAccountsDetails);

  useEffect(() => {
    // dispatch(GetGlChartOfAccountsDetailsList());
    if (ChartDetiles?.length === 0) {
      dispatch(GetGlChartOfAccountsDetailsList());
    }
  }, [ChartDetiles?.length, dispatch]);

  // console.log(ChartAccountsDetails);
  
  const ChartConfig = {
    maxLevel: ChartAccountsDetails.maxLevel,
    level2: ChartAccountsDetails.level2,
    level3: ChartAccountsDetails.level3,
    level4: ChartAccountsDetails.level4,
    level5: ChartAccountsDetails.level5,
    level6: ChartAccountsDetails.level6,
    level7: ChartAccountsDetails.level7
  };
  // const ChartConfig = {
  //   maxLevel: 6,
  //   level2: 1,
  //   level3: 1,
  //   level4: 1,
  //   level5: 2,
  //   level6: 4,
  //   level7: null
  // };




  var Accounts = ChartDetiles?.filter(f => f.accountlevel === 4);
  var Companies = ChartDetiles?.filter(f => f.accountType === 'Company');
  var Branches = ChartDetiles?.filter(f => f.accountType === 'Branch');

  var CostCenters = ChartDetiles?.filter(f => f.accountType === 'CostCenter' && f.accountParant !== null);

  //___ Options _____
  var OptionsBranches = Branches?.map(({ id, name, name2, accountNumber, accountParant }) => ({
    value: id,
    label: `${i18n.language === 'en' ? name : name2} | ${accountNumber}`,
    accountParant: accountParant,
    accountNumber: accountNumber
  }));

  var OptionsAccounts = Accounts?.map(({ id, name, name2, accountNumber, accountParant }) => ({
    value: id,
    label: `${i18n.language === 'en' ? name : name2} | ${accountNumber}`,
    accountParant: accountParant,
    accountNumber: accountNumber
  }));

  var OptionsCompanies = Companies?.map(({ id, name, name2, accountNumber, accountParant }) => ({
    value: id,
    label: `${i18n.language === 'en' ? name : name2} | ${accountNumber}`,
    accountParant: accountParant,
    accountNumber: accountNumber
  }));

  var OptionsCostCenters = CostCenters?.map(({ id, name, name2, accountNumber, accountParant }) => ({
    value: id,
    label: `${i18n.language === 'en' ? name : name2} | ${accountNumber}`,
    accountParant: accountParant,
    accountNumber: accountNumber
  }));
  //________

  //#region  // ___Start TreeSelect CostCenter _____
  const BildCostCentersTree = (list: any, parentId: any) => {
    return list
      ?.filter((item: any) => item.accountParant === parentId)
      ?.map((item: any) => ({
        title: `${i18n.language === 'en' ? item.name : item.name2} | ${item.accountNumber}`,
        value: item.id,
        accountNumber: item.accountNumber,
        children: BildCostCentersTree(list, item.id)
      }));
  };
  const TreeCostCenters = BildCostCentersTree(ChartDetiles, '7a5a0a0d-00d9-4b8f-9f6a-8ebe1f851b47');
  //#endregion

  //#region  // ___Start TreeSelect Companies _____
  const buildCompaniesTree = (list: any, parentId: any) => {
    return list
      ?.filter((item: any) => item.accountParant === parentId)
      ?.map((item: any) => ({
        title: i18n.language === 'en' ? item.name : item.name2,
        value: item.id,
        disabled: item.accountType === 'Branch',
        children: buildCompaniesTree(list, item.id)
      }));
  };
  const TreeCompanies = buildCompaniesTree(ChartDetiles, '69b480f1-f40b-4e77-9e66-9b75d98395a7');
  //#endregion

  //#region  // ___Start TreeSelect branches _____
  const buildBranchesTree = (list: any, parentId: any) => {
    return list
      ?.filter((item: any) => item.accountParant === parentId)
      ?.map((item: any) => ({
        title: i18n.language === 'en' ? item.name : item.name2,
        value: item.id,
        disabled: item.accountType === 'Company', // تعطيل خيار الشركات
        children: buildBranchesTree(list, item.id)
      }));
  };
  const TreeBranches = buildBranchesTree(ChartDetiles, '69b480f1-f40b-4e77-9e66-9b75d98395a7');
  //#endregion

  //_______
  return {
    Chart: ChartAccountsDetails, //  كاملة
    ChartAccountsDetailsList: ChartDetiles, // القائمة - حسابات - فروع - شركات
    ChartConfig,
    //
    Accounts,
    Companies,
    Branches,
    CostCenters,
    loading,
    error,
    //
    OptionsAccounts,
    OptionsBranches,
    OptionsCompanies,
    OptionsCostCenters,
    TreeCostCenters,
    TreeCompanies,
    TreeBranches
  };
};

export default useGetChartAccountsDetailsList;
